import script from "./CabecalhoFormGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./CabecalhoFormGroup.vue?vue&type=script&setup=true&lang=js"

import "./CabecalhoFormGroup.vue?vue&type=style&index=0&id=58ec9f36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ec9f36"]])

export default __exports__